import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

export default function ProveedoresBar({
  hide,
  handleChange,
  miFabricante,
  misFabricantes,
  loading,
}) {
  const drawFabricantesOptions = misFabricantes => misFabricantes.map(fabricante => (
    <Select.Option
      key={fabricante.id}
      value={fabricante.id}
    >
      {fabricante.proveedor}
    </Select.Option>
  ));
  return (
    <div>
      {!hide
        && (
        <Select
          showSearch
          value={miFabricante? miFabricante.id:undefined}
          placeholder="Sel. proveedor"
          optionFilterProp="children"
          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          style={{ width: 142 }}
          onChange={handleChange}
          loading={loading}
        >
          {drawFabricantesOptions(misFabricantes)}
        </Select>
        )
      }
    </div>
  );
}

ProveedoresBar.propTypes = {
  handleChange: PropTypes.func,
  misFabricantes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    empresaId: PropTypes.number,
    esCliente: PropTypes.bool,
    proveedor: PropTypes.string,
    activa: PropTypes.number,
  })).isRequired,
  loading: PropTypes.bool,
  hide: PropTypes.bool,
};
ProveedoresBar.defaultProps = {
  handleChange: () => {},
  loading: false,
  hide: false,
};
